import { esES as coreES } from '@mui/material/locale';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid';
import breakpoints from '@fingo/lib/theme/breakpoints';
import components from '@fingo/lib/theme/fingo/components';
import bancoDeChileComponents from '@fingo/lib/theme/banco-de-chile/components';
import palette from '@fingo/lib/theme/banco-de-chile/palette';
import typography from '@fingo/lib/theme/banco-de-chile/typography';
import branding from '@fingo/lib/theme/banco-de-chile/branding';

const theme = createTheme(
  {
    palette,
    breakpoints,
    typography,
    components: {
      ...components,
      ...bancoDeChileComponents,
    },
    branding,
  },
  coreES,
  esES,
);

theme.typography.body2 = {
  ...theme.typography.body2,
  [theme.breakpoints.down('md')]: {
    fontSize: 10,
  },
};

export default responsiveFontSizes(theme);
